





























import { mapActions, mapState } from 'vuex'
import QnaComment from './QnaComment.vue'
import { QnaComment as QnaCommentType, QnaQuestion } from '~/models/qna/types'
import { ReactionEnum } from '~/models/classified-list/types'
import CReportModal from '~/components/shared/configurable/modal/CReportModal.vue'
import QnaService from '~/services/qna/QnaService'
import { mapDeps } from '~/plugins/dependency-container/utils'
import SnackbarService from '~/services/snackbar/SnackbarService'
import { QNA_NS } from '~/store/modules/shared/qna/state'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    QnaComment,
    CReportModal
  },
  props: {
    firstCommentOnly: { type: Boolean, default: false },
    questionId: { type: String, required: true },
    hasMoreVisible: { type: Boolean, default: true },
    seoUrl: { type: String, default: null }
  },
  data() {
    return {
      commentToReport: null,
      isReportFormVisible: false
    }
  },

  computed: {
    ...mapState(QNA_NS, {
      questions: state => state.questions,
      stateComments: state => state.comments
    }),
    ...mapDeps({
      qnaService: QnaService,
      snackbar: SnackbarService
    }),

    reportService(): QnaService {
      return this.qnaService
    },

    comments(): QnaCommentType {
      if (this.firstCommentOnly) {
        const question = this.currentQuestion
        if (question) {
          return [question.questionFirstComment]
        }
        return []
      }
      return this.stateComments
    },
    currentQuestion(): QnaQuestion {
      return this.questions.find(q => q.id === this.questionId)
    },
    firstComment(): QnaCommentType {
      return this.firstCommentOnly
        ? this.currentQuestion?.questionFirstComment
        : null
    }
  },
  methods: {
    ...mapActions(QNA_NS, [
      'createQuestionReaction',
      'addCommentReply',
      'addCommentReaction',
      'deleteComment',
      'changeCommentVisibility',
      'fetchMoreComments',
      'updateComment'
    ]),
    handleReport(commentId: number) {
      this.commentToReport = commentId
      this.isReportFormVisible = true
    },

    handleDataReaction(comment: QnaCommentType, reaction: ReactionEnum) {
      this.addCommentReaction({ commentId: comment.id, reaction })
    },
    handleReportModalVisibilityChange() {
      this.commentToReport = null
      this.isReportFormVisible = false
    },
    handleCommentReply({ commentId, comment }) {
      this.addCommentReply({
        questionId: this.questionId,
        commentId,
        comment,
        isFirstComment: this.firstComment
      })
    },

    handleReaction({
      commentId,
      reaction
    }: {
      commentId: number
      reaction: ReactionEnum
    }) {
      this.addCommentReaction({
        commentId,
        reaction,
        firstComment: this.firstComment
      })
    },
    handleUpdateComment({
      comment,
      commentId
    }: {
      comment: string
      commentId: number
    }) {
      this.updateComment({
        comment,
        commentId,
        isFirstComment: this.firstCommentOnly,
        questionId: this.questionId
      })
    },
    handleDeleteComment(comment: QnaCommentType) {
      this.deleteComment({
        comment,
        isFirstComment: this.firstCommentOnly,
        questionId: this.questionId
      })
    },
    handleChangeVisibility({ commentId, isHidden }) {
      this.changeCommentVisibility({
        commentId,
        isHidden,
        isFirstComment: this.firstCommentOnly,
        questionId: this.questionId
      })
    }
  }
})
